import DialogStore from 'bz-stores/mobx/dialog-store';
import { action, computed, observable } from 'mobx';
import { PaywallContent } from '../paywall-content';
import type { IPaywallDialogContent } from '../paywall-content';

import { EPaywallTypes } from '../paywall-content';
import JsonServiceClient from 'bz-stores/lib/JsonServiceClient';
import { ClickPPCDetailsRequest } from 'tm3-core/api.dtos';

type TPaywallCallback = () => void;
class PaywallDialogStore extends DialogStore {
  client: JsonServiceClient;
  @observable type: EPaywallTypes | null = null;
  @observable callback?: TPaywallCallback;

  @observable rate: number = 0;

  constructor() {
    super();
    this.client = new JsonServiceClient();
  }

  @action.bound
  async onOpen(type: EPaywallTypes, callback?: TPaywallCallback) {
    this.type = type;
    this.callback = callback;
    try {
      const res = await this.client.get(new ClickPPCDetailsRequest());
      const { smsRate, telehealthRate, formsRate } = res.result;
      switch (type) {
        case EPaywallTypes.SMS:
          this.rate = smsRate;
          break;
        case EPaywallTypes.Telehealth:
          this.rate = telehealthRate;
          break;
        case EPaywallTypes.Forms:
          this.rate = formsRate;
          break;
        default:
          this.rate = this.content.DEFAULTRATE;
      }
    } catch (e) {
      // we don't want mothership errors blocking usage
      console.error('Error Getting Mothership PPC Details', e);
      this.rate = this.content.DEFAULTRATE;
    }

    this.open();
  }

  @action.bound
  onClose() {
    this.type = null;
    this.callback = undefined;
    this.close();
  }

  @action.bound
  close() {
    this._close();
  }

  @computed
  get content(): IPaywallDialogContent {
    if (!this.type) return {};
    return PaywallContent[this.type];
  }
}

export default PaywallDialogStore;
